<script lang="ts" setup>
import BPTQuestionForm from '@/components/bpt/BPTQuestionForm.vue';
import BPTQuestionsSortingForm from '@/components/bpt/BPTQuestionsSortingForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { BPTQuestion } from '@/models/bpt.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { BPTStoreActions, BPTStoreState } from '@/stores/bpt.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { bpt: BPTStoreState }>();
const events = useEvents();

const questions = computed<BPTQuestion[]>(() => store.state.bpt.questions);

const update = () => {
  store.dispatch(BPTStoreActions.GetBPTQuestions);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Title', key: 'text', width: '50%' },
  { title: 'Type', key: 'type', width: '35%' },
  { title: 'Onboarding', key: 'onboarding', width: '5%' },
  { title: 'State', key: 'translated', sortable: false, width: '5%' },
];

const editQuestion = (_: Event, { item }: { item: BPTQuestion }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionForm),
    data: item,
  });
};

const addQuestion = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionForm),
  });
};

const sortQuestions = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionsSortingForm),
    data: questions,
  });
};

const filterTitle = ref<string>('');
const filteredQuestions = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.text.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}
</script>
<template>
  <v-container>
    <h2>Behavior & Profile Tracker <CurrentLanguage /></h2>
    <ListFilter @filter="updateFilter" />
    <v-data-table
      density="compact"
      :headers="headers"
      :items="filteredQuestions.sort((a, b) => a.index - b.index)"
      @click:row="editQuestion"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.onboarding="{ value }">
        {{ value ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.translated="{ item }">
        <TranslatedState :item="item" />
      </template>
    </v-data-table>

    <v-btn @click="addQuestion" color="success" class="mr-4"
      >Add Question</v-btn
    >
    <v-btn @click="sortQuestions" color="success">Sort and Hierarchy</v-btn>
  </v-container>
</template>
